export const ACTION_NAMES = {
  FETCH_LOGIN_DETAILS: "/fetch/loginDetails",
  FETCH_EMPLOYEE_DASHBOARD_DETAILS: "/fetch/employeeDashboardDetails",
  FETCH_EMPLOYEE_DASHBOARD_POP_UP_DETAILS: "/fetch/employee/dashboard-popup",
  FETCH_ASSIGNED_MANAGER_TO_EMPLOYEE: "/fetch/assignedManagerToEmployee",
  FETCH_EMPLOYEES_LIST: "/fetch/employeesList",
  FETCH_EMPLOYEE_LEAVE_TYPES: "/fetch/employeeLeaveTypes",
  FETCH_EMPLOYEE_LEAVE_LIST: "/fetch/employeeLeaveList",
  FETCH_EMPLOYEE_LEAVE_COMP_OFF: "/fetch/employeeLeaveCompOff",
  FETCH_EMPLOYEE_CONVEYANCE_LIST: "/fetch/employeeConveyanceList",
  FETCH_EMPLOYEE_SALARY_REPORT: "/fetch/report/employeeSalaryReport",
  FETCH_EMPLOYEE_LEAVE_REPORT: "/fetch/report/employeeLeaveReport",
  FETCH_EMPLOYEE_UNDER_PROBATION_LIST: "/fetch/hrZone/employeeUnderProbation",
  FETCH_EMPLOYEE_MONTHLY_WISE_REPORT_LIST: "/fetch/employeeMonthlyWiseReport",

  FETCH_TRAINING_VIDEOS: "/fetch/trainingVideos",
  FETCH_TEAM_MEMBERS: "/fetch/teamMembers",
  FETCH_TEAM_MEMBERS_LEAVE: "/fetch/teamMembersLeave",
  FETCH_TEAM_MEMBERS_ATTENDANCE: "/fetch/teamMembersAttendance",
  FETCH_TEAM_MEMBERS_CONVEYANCE: "/fetch/teamMembersConveyance",
  FETCH_TEAM_MEMBERS_DAILY_DAIRY_REPORT: "/fetch/teamMembers/DailyDairyReport",
  FETCH_MIS_DOWNLOAD_DETAILS: "/fetch/misDownloadFolders",

  FETCH_DAILY_REPORT_LIST: "/fetch/dailyReportList",
  FETCH_EDUCATION_LIST: "/fetch/educationList",
  FETCH_DOCUMENT_TYPES: "/fetch/documentTypeDetails",
  FETCH_CENTERS_LIST: "/fetch/centersList",
  FETCH_DEPARTMENT_LIST: "/fetch/departmentList",
  LIST_DESIGNATION: "/fetch/designationList",
  FETCH_DEPARTMENT_WISE_TASKS_LIST: "/fetch/departmentWiseTaskList",
  FETCH_DEPARTMENT_WISE_TASK_OPTIONS: "/fetch/departmentWiseTaskOptions",
  FETCH_DEPARTMENT_WISE_SUB_CATEGORY_TASKS_LIST:
    "/fetch/departmentWiseSubcategoryTaskList",
  FETCH_SUB_DEPARTMENT_LIST: "/fetch/subDepartmentList",
  FETCH_EMPLOYEE_ATTENDANCE_DETAILS: "/fetch/employeeAttendanceDetails",
  FETCH_EMPLOYEE_PROFILE_DETAILS: "/fetch/employeeProfileDetails",
  FETCH_EMPLOYEE_REIMBURSEMENT_LIST: "/fetch/employeeReimbursementList",
  FETCH_EMPLOYEE_REIMBURSEMENT_CATEGORY_LIST:
    "/fetch/employeeReimbursement/categories,",
  FETCH_IMBURSEMENT_BILL_VIEW: "/fetch/imbursement/billView",
  FETCH_PETTY_CASH_EXPENSE_CATEGORIES:
    "/fetch/employeePettyCash/expense/categories",
  FETCH_EMPLOYEE_PETTY_CASH_EXPENSE_LIST:
    "/fetch/employeePettyCash/expense/list",
  FETCH_EMPLOYEE_PETTY_CASH_ACCOUNT_ZONE_DASHBOARD:
    "/fetch/employeePettyCash/accountZone/dashboard",
  FETCH_HR_EMPLOYEE_MASTER_DATA: "/fetch/hr/employeeMasterData",
  FETCH_REIMBURSEMENT_REPORT: "/fetch/report/reimbursement",
  FETCH_CONVEYANCE_REPORT: "/fetch/report/conveyance",
  FETCH_EMPLOYEE_TYPES: "/fetch/employeeTypes",

  EMPLOYEE_OFFICIAL_INFORMATION_UPDATE: "/mutate/employeeOfficialInformation",
  EMPLOYEE_PERSONAL_INFORMATION_UPDATE: "/mutate/employeePersonalInformation",
  EMPLOYEE_WORK_INFORMATION_UPDATE: "/mutate/employeeWorkInformation",
  EMPLOYEE_FINANCIAL_INFORMATION_UPDATE: "/mutate/financialInformation",
  EMPLOYEE_FAMILY_INFORMATION_UPDATE: "/mutate/employeeFamilyInformation",
  EMPLOYEEU_EDUCATION_INFORMATION_UPDATE:
    "/mutate/employeeEducationInformation",
  EMPLOYEE_CONVEYANCE_ADD: "/mutate/employeeConveyanceAdd",
  EMPLOYEE_ATTENDANCE_CORRECTION: "/mutate/employeeAttendanceCorrection",
  EMPLOYEE_RESET_PASSWORD_EMAIL_SLICE: "/mutate/employeeResetPassword",
  EMPLOYEE_CHANGE_PASSWORD: "/mutate/employeeChangePassword",
  EMPLOYEE_ATTENDANCE_PUNCH: "/mutate/markAttendance",
  EMPLOYEE_UPDATE_PROFILE_PIC: "/update/employee-update-profile-pic",

  EXPORT_FETCH_HR_EMPLOYEE_MASTER_DATA: "/export/fetch/hr/employeeMasterData",
  EXPORT_REIMBURSEMENT_REPORT: "/export/reimbursementReport",
  EXPORT_CONVEYANCE_REPORT: "/export/conveyanceReport",
  EXPORT_BULK_EMPLOYEE_ATTENDANCE_REPORT: "/export/employeeAttendanceReport",

  ADD_BALANCE_PETTY_CASH_ACCOUNT_ZONE: "/pettyCash/addBalance/accountZone",
  EDIT_DESIGNATION: "/mutate/editDesignation",
  EMPLOYEE_APPLY_LEAVE: "/mutate/employeeLeaveApply",
  FETCH_SURVEY_FORMS: "/fetch/surveyForms",
  FETCH_SURVEY_FORMS_INVITED_EMPLOYEES: "/fetch/invitedEmployees",
  FETCH_ASSIGN_SURVEY_FORM_TO_EMPLOYEES: "/fetch/assignSurveyFormToEmployees",
  EDIT_DEPARTMENT: "/mutate/editDepartment",
  CHANGE_STATUS_SURVEY_QUESTION: "/mutate/changeStatusSurveyQuestion",
  UPDATE_SURVEY_FORM_STATUS: "/mutate/updateSurveyFormStatus",
  FETCH_SURVEY_FORM_RESPONSE: "/fetch/surveyFormResponse",
  CREATE_SURVEY_FORM: "/mutate/createSurveyForm",
  CREATE_DEPARTMENT: "/mutate/createDepartment",
  ADD_SURVEY_FORM_QUESTION: "/mutate/addSurveyFormQuestion",
  SUBMIT_SURVEY_FORM_RESPONSE: "/mutate/submitSurveyFormResponse",
  UPDATE_DEPARTMENT: "/mutate/updateDepartment",
  UPDATE_DEPARTMENT_STATUS: "/mutate/updateDepartmentStatusThunk",
  SURVEY_FORM_WITH_QUESTIONS: "/fetch/surveyFormWithQuestions",
  UPDATE_APPROVE_LEAVE: "/mutate/teamMemeberLeaveApproval",

  INITIATE_EXIT: "/mutate/initiateExit",
  UPLOAD_DAILY_REPORT: "/mutate/uploadDailyReport",
  UPDATE_TEAM_MEMBERS_ATTENDANCE_CORRECTION:
    "/mutate/teamMembersAttendanceApproval",

  DOWNLOAD_DAILY_REPORT: "/mutate/downloadDailyReport",
  EMPLOYEE_REIMBURSEMENT_ADD: "/mutate/employeeReimbursementAdd",
  EMPLOYEE_PETTY_CASH_EXPENSE_ADD: "/mutate/employeePettyCashExpenseAdd",
  UPDATE_EMPLOYEE_MANAGER: "/mutate/employeeManager",
  UPDATE_EMPLOYEE_STATUS: "/mutate/employeeStatus",
  UPDATE_EMPLOYEE_EDIT_OPTION: "/mutate/employeeEditOption",
  EMPLOYEE_CALLING_SYSTEM_UPDATE_STATUS:
    "/mutate/employeeCallingSystemUpdateStatus",
  UPDATE_BULK_ATTENDANCE_APPROVED: "/mutate/bulkAttendanceApproved",
  UPDATE_BULK_LEAVE_REQUESTS_APPROVED: "/mutate/bulkLeaveRequestApproved",
  UPDATE_HR_EMPLOYEE_BULK_ATTENDANCE_CORRECTION:
    "/mutate/markEmployeeBulkAttendanceCorrection",
  UPDATE_EMPLOYEE_PROBATION: "/mutate/employeeUpdateProbation",
  EMPLOYEE_PETTY_CASH_EXPENSE_DELETE: "/delete/employeePettyCashExpense",
  EMPLOYEE_CONVEYANCE_DELETE: "/delete/employeeConveyance",
  EMPLOYEE_REIMBURSEMENT_DELETE: "/delete/employeeReimbursement",
  CREATE_DEPARTMENT_CATEGORY: "/create/departmentCategory",
  DELETE_DEPARTMENT_CATEGORY: "/delete/departmentCategory",
  CLOSE_DAILY_DAIRY: "/closeDailyDairy",
  SUBMIT_DAILY_DAIRY: "/submitDailyDairy",
  FETCH_DAILY_DAIRY_SLOTS: "/fetchDailyDairySlots",
  SAVE_UPDATE_DESIGNATION: "/mutate/saveUpdateDesignation",
  EDIT_SECTION: "/fetch/editSection",
  EDIT_SURVEY_FORM: "/mutate/editSurveyForm",
  SAVE_UPDATE_SECTION: "/fetch/saveUpdateSection",
  SAVE_UPDATE_SURVEY_FORM: "/mutate/createUpdateSurveyForm",
  LIST_SECTION: "/fetch/sectionList",
  GET_FORM_RESPONSES: "/fetch/getFormResponses",
  FETCH_USER_TYPE_LIST: "/fetch/userTypesList",
  SEND_PROBATION_REMINDER_MAIL: "/mutate/sendProbationReminderMail",
  FETCH_INVENTORY_CATEGORY_LIST: "/fetch/fetchInventoryCategories",
  SAVE_UPDATE_INVENTORY_CATEGORY: "/fetch/saveUpdateInventoryCategory",
  EDIT_INVENTORY_CATEGORY: "/fetch/editInventoryCategory",
  FETCH_INVENTORY_VENDOR_LIST: "/fetch/fetchInventoryVendors",
  SAVE_UPDATE_INVENTORY_VENDOR: "/fetch/saveUpdateInventoryVendor",
  EDIT_INVENTORY_VENDOR: "/fetch/editInventoryVendor",
  FETCH_INVENTORY_PRODUCT_LIST: "/fetch/fetchInventoryProducts",
  SAVE_INVENTORY_PRODUCT: "/fetch/saveInventoryProduct",
  EDIT_INVENTORY_PRODUCT: "/fetch/editInventoryProduct",
  UPDATE_INVENTORY_PRODUCT: "/fetch/updateInventoryProduct",
  SAVE_INVENTORY_ACTION: "/fetch/saveInventoryAction",
  FETCH_EMPLOYEE_INVENTORY_PRODUCT_LIST: "/fetch/fetchEmployeeIventoryProductList",
  FETCH_INVENTORY_PRODUCT_LOGS: "/fetch/fetchInventoryProductLogs",
  SEND_INVENTORY_ACTION_OTP: "/fetch/sendInventoryActionOtp",
  FETCH_INVENTORY_BRAND_LIST: "/fetch/fetchInventoryBrandList",
};

export const SLICE_NAMES = {
  EMPLOYEE_APPLY_LEAVE: "employeeApplyLeaveSlice",
  EMPLOYEE_LEAVE_TYPES: "employeeLeaveTypesSlice",
  EMPLOYEE_LEAVE_LIST: "employeeLeaveListSlice",
  EMPLOYEE_ATTENDANCE_LIST: "employeeAttendanceListSlice",
  EMPLOYEE_OFFICIAL_INFORMATION: "employeeOfficialInformationSlice",
  EMPLOYEE_PERSONAL_INFORMATION: "employeePersonalInformationSlice",
  EMPLOYEE_WORK_INFORMATION: "employeeWorkInfomationSlice",
  EMPLOYEE_FINANCIAL_INFORMATION: "employeeFinancialInformationSlice",
  EMPLOYEE_FAMILY_INFORMATION: "employeeFamilyInformationSlice",
  EMPLOYEE_EDUCATION_INFORMATION: "employeeEducationInformationSlice",
  EMPLOYEE_PROFILE_DETAILS: "employeeProfileDetailsSlice",
  EMPLOYEE_ATTENDANCE_CORRECTION: "employeeAttendanceCorrectionSlice",
  EMPLOYEE_RESET_PASSWORD_EMAIL_SLICE: "employeeResetPasswordEmailSlice",
  EMPLOYEE_CHANGE_PASSWORD_SLICE: "employeeChangePasswordSlice",
  EMPLOYEE_UPDATE_PROFILE_PIC_SLICE: "employeeUpdateProfilePicSlice",
  EMPLOYEE_CONVEYANCE_LIST: "employeeConveyanceListSlice",
  EMPLOYEE_CONVEYANCE_ADD: "employeeConveyanceAddSlice",
  EMPLOYE_CONVEYANCE_DELETE: "employeeConveyanceDeleteSlice",
  EMPLOYEE_LEAVE_REPORT_SLICE: "employeeLeaveReportSlice",
  EMPLOYEE_SALARY_REPORT_SLICE: "employeeSalaryReportSlice",
  EMPLOYEE_MONTHLY_WISE_REPORT_SLICE: "employeeMonthlyWiseReportSlice",
  EMPLOYEE_CALLING_SYSTEM_UPDATE_STATUS:
    "employeeCallingSystemUpdateStatusSlice",
  EMPLOYEE_PETTY_CASH_EXPENSE_DELETE: "employeePettyCashExpenseDeleteSlice",
  EMPLOYEE_PETTY_CASH_EXPENSE_ADD: "employeePettyCashExpenseAddSlice",
  EMPLOYEE_PETTY_CASH_EXPENSE_LIST: "employeePettyCashExpenseListSlice",
  EMPLOYEE_PETTY_CASH_ACCOUNT_ZONE:
    "employeePettyCashAccountZoneDashboardSlice",
  EMPLOYEE_PETTY_CASH_ACCOUNT_ZONE_ADD_BALANCE:
    "employeePettyCashAccountZoneAddBalance",
  EMPLOYEE_PETTY_CASH_EXPENSE_CATEGORY: "employeePettyCashExpenseCategorySlice",

  TEAM_MEMBERS: "teamMembersSlice",
  TEAM_MEMBERS_LEAVE: "teamMembersLeaveSlice",
  TEAM_MEMBERS_ATTENDANCE: "teamMembersAttendanceSlice",
  TEAM_MEMBERS_CONVEYANCE: "teamMembersConveyanceSlice",
  TEAM_MEMBERS_ATTENDANCE_APPROVE: "teamMembersAttendanceApproveSlice",
  TEAM_MEMBERS_DAILY_DAIRY_REPORT: "teamMembersDailyDairyReport",

  EMPLOYEE_REIMBURSEMENT_LIST: "employeeReimbursementListSlice",
  EMPLOYEE_REIMBURSEMENT_CATEGORY_LIST:
    "employeeReimbursementCategoryListSlice",
  IMBURSEMENT_BILL_VIEW_SLICE: "imbursementBillViewSlice",
  EMPLOYEE_REIMBURSEMENT_DELETE: "employeeReimbursementDeleteSlice",

  LOGIN_DETAILS_SLICE: "loginDetails",
  EMPLOYEE_DASHBOARD_DETAILS: "employeeDashboardDetailsSlice",
  EMPLOYEE_DASHBOARD_POP_UP: "employeeDashboardPopUpSlice",
  APPROVED_LEAVE: "approvedLeaveSlice",

  INITIATE_EXIT: "initiateExitSlice",
  ASSIGNED_MANAGER_TO_EMPLOYEE: "employeeAssignedManagerToEmployeeSlice",
  USER_LIST: "userListSlice",
  SURVEY_FORMS: "surveyFormSlice",
  SURVEY_FORMS_INVITED_EMPLOYEES: "surveyFormInvitedEmployeesSlice",
  ASSIGN_SURVEY_FORM_TO_EMPLOYEES: "assignSurveyFornInvitedEmployeesSlice",
  EDIT_DEPARTMENT: "editDepartmentSlice",
  CHANGE_STATUS_SURVEY_QUESTION_SLICE: "changeStatusSurveyQuestionSlice",
  UPDATE_SURVEY_FORM_STATUS_SLICE: "updateSurveyFormStatusSlice",
  SURVEY_FORM_RESPONSE: "surveyFormResponseSlice",
  CREATE_SURVEY_FORM: "createSurveyFormSlice",
  CREATE_DEPARTMENT: "createDepartmentSlice",
  SURVEY_FORM_QUESTION_ADD: "surveyFormQuestionAddSlice",
  SURVEY_FORM_RESPONSE_SUBMIT_SLICE: "surveyFormResponseSubmitSlice",
  UPDATE_DEPARTMENT: "updateDepartmentSlice",
  UPDATE_DEPARTMENT_STATUS: "toggleDepartmentStatusSlice",
  SURVEY_FORM_WITH_QUESTIONS: "surveyFormWithQuestionsSlice",
  UPLOAD_DAILY_REPORT: "uploadDailyReportSlice",
  TRAINING_VIDEOS: "trainingVideoDetailsSlice",

  MIS_DOWNLOAD_DETAILS: "misDownloadDetailsSlice",
  LEAVE_USER_DETAILS: "leaveUserDetailsSlice",
  EMPLOYEE_LEAVE_COMP_OFF: "employeeLeaveCompOffSlice",
  DAILY_REPORT_LIST: "dailyReportListSlice",
  EDUCATION_LIST: "educationListSlice",
  DOWNLOAD_DAILY_REPORT: "downloadDailyReportSlice",
  DOCUMENT_TYPES: "documentTypeSlice",

  CENTERS_LIST: "centersListSlice",
  DEPARTMENT_LIST_SLICE: "departmentList",
  DESIGNATION_LIST_SLICE: "designationListSlice",
  SUBDEPARTMENT_LIST: "subDepartmentListSlice",
  DEPARTMENT_CATEGORY_LIST: "departmentCategoryList",
  DEPARTMENT_CATEGORY_OPTIONS: "departmentCategoryOptions",
  DEPARTMENT_SUB_CATEGORY_LIST: "departmentSubCategoryList",

  EMPLOYEE_REIMBURSEMENT_ADD_SLICE: "employeeReImbursementAddSlice",

  UPDATE_EMPLOYEE_MANAGER_SLICE: "updateEmployeeManagerSlice",
  UPDATE_EMPLOYEE_STATUS_SLICE: "updateEmployeeStatusSlice",
  UPDATE_EMPLOYEE_EDIT_OPTION_SLICE: "updateEmployeeEditOptionSlice",
  UPDATE_EMPLOYEE_PROBATION_SLICE: "updateEmployeeProbationSlice",
  EMPLOYEE_ATTENDANCE_PUNCH_SLICE: "markAttendanceUserSlice",
  BULK_ATTENDANCE_APPROVED_SLICE: "bulkAttendanceApprovedSlice",
  HR_BULK_ATTENDANCE_APPROVED_SLICE:
    "hrMarkBulkEmployeeAttendanceCorrectionSlice",
  HR_EMPLOYEE_MASTER_DATA_SLICE: "hrEmployeeMasterDataSlice",
  REIMBURSEMNET_REPORT_SLICE: "employeesReimbursementReport",

  EXPORT_HR_EMPLOYEE_MASTER_DATA_SLICE: "exportHrEmployeeMasterDataSlice",
  EXPORT_REIMBURSEMENT_REPORT: "exportReimbursementSlice",
  CONVEYANCE_REPORT_SLICE: "conveyanceReportSlice",
  EXPORT_CONVEYANCE_REPORT_SLICE: "exportConveyanceReportSlice",
  EXPORT_BULK_EMPLOYEE_ATTENDANCE_REPORT_SLICE:
    "exportBulkEmployeeAttendanceReportSlice",
  EMPLOYEE_PROBATION_SLICE: "employeeProbationSlice",
  BULK_APPROVED_REQUEST_LEAVE_SLICE: "bulkApprovedRequestLeaveSlice",
  CREATE_DEPARTMENT_TASK_SLICE: "createDepartmentCategory",
  DEPARTMENT_CATEGORY_STATES: "departmentCategoryState",
  DELETE_DEPARTMENT_CATEGORY_SLICE: "deleteDepartmentCategory",
  CLOSE_DAILY_DAIRY_SLICE: "closeDailyDairy",
  SUBMIT_DAILY_DAIRY_SLICE: "submitDailyDairy",
  DAILY_DAIRY_SLOTS_SLICE: "dailyDairySlots",
  EDIT_DESIGNATION_SLICE: "editDesignationSlice",
  SAVE_UPDATE_DESIGNATION_SLICE: "saveUpdateDesignationSlice",
  EDIT_SECTION_SLICE: "editSectionSlice",
  EDIT_SURVEY_FORM_SLICE: "editSurveyFormSlice",
  SAVE_UPDATE_SECTION_SLICE: "saveUpdateSectionSlice",
  SAVE_UPDATE_SURVEY_FORM_SLICE: "saveUpdateSurveyFormSlice",
  SECTION_LIST_SLICE: "sectionListSlice",
  FORM_RESPONSES_SLICE: "formResponsesSlice",
  USER_TYPE_LIST: "userTypesSlice",
  PROBATION_REMINDER_MAILER_SLICE: "probationReminderMailerSlice",
  EMPLOYEE_TYPES_SLICE : "employeesTypesSlice",
  INVENTORY_CATEGORY_LIST_SLICE: "inventoryCategorySlice",
  SAVE_UPDATE_INVENTORY_CATEGORY_SLICE: "saveUpdateInventoryCategorySlice",
  EDIT_INVENTORY_CATEGORY_SLICE: "editInventoryCategorySlice",
  INVENTORY_VENDOR_LIST_SLICE: "inventoryVendorSlice",
  SAVE_UPDATE_INVENTORY_VENDOR_SLICE: "saveUpdateInventoryVendorSlice",
  EDIT_INVENTORY_VENDOR_SLICE: "editInventoryVendorSlice",
  INVENTORY_PRODUCT_LIST_SLICE: "inventoryProductSlice",
  SAVE_INVENTORY_PRODUCT_SLICE: "saveUpdateInventoryProductSlice",
  EDIT_INVENTORY_PRODUCT_SLICE: "editInventoryProductSlice",
  UPDATE_INVENTORY_PRODUCT_SLICE: "updateInventoryProductSlice",
  SAVE_INVENTORY_ACTION_SLICE: "saveInventoryActionSlice",
  EMPLOYEE_INVENTORY_PRODUCT_LIST_SLICE : "employeeInventoryProductSlice",
  INVENTORY_PRODUCT_LOGS_SLICE: "inventoryProductLogsSlice",
  SEND_INVENTORY_ACTION_OTP_SLICE: "sendInventoryActionOtpSlice",
  INVENTORY_BRAND_LIST_SLICE: "inventoryBrandSlice",
} as const;
